// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Mwj1C","label":"LabeledBox_label__2KfbC"};